import URL from '@/creditflowresearch/Router/urlConstants';

export const ABS_PATH_PATTERNS = [
  URL.MARKET_OVERVIEW_ALL,
  URL.ABS_BONDSCREENER,
  URL.MARKET_OVERVIEW_CONSUMER,
  URL.BONDS_INVENTORIES,
  URL.PRODUCT_US_ABS_PIPELINE,
  URL.NRSRO_RESEARCH,
  URL.TRACE,
  URL.SECTOR_SUFFIX,
] as const;

export const CORPORATE_PATH_PATTERNS = [
  URL.MARKET_OVERVIEW_HYC,
  URL.MARKET_OVERVIEW_IGC,
  URL.CORPORATE_BONDSCREENER,
  URL.INDUSTRY_SUFFIX,
] as const;
